import * as yup from "yup"

export const max = {
  fullname: [50, "ניתן להזין עד 50 תווים"] as [number, string],
}

export const required = {
  default: "שדה זה הינו שדה חובה",
  firstName: "יש להזין שם פרטי",
  lastName: "יש להזין שם משפחה",
  phoneNumber: "יש להזין מספר טלפון",
  licenseNumber: "יש להזין לוחית רישוי",
  licenceOrChassis: "נא הכנס מספר רישוי או שילדה",
  modelId: "בחר דגם",
  area: "בחר איזור",
  skuOrName: "נא הכנס טקסט חופשי או מספר פריט",
}

export const regex = {
  numbers: /^[0-9]*$/,
  singleName: /^[a-zA-Zא-ת׳״ء-ي'"‘’\\.\-,\s]+$/,
  fullName: /([a-zA-Zא-תء-ي'"\\.-/,].+\s).+/,
  name: /^[A-Za-zء-ي ,.'-]+$/,
  phoneNumber: /^05(\d+-?)+\d+$/,
  phoneNumberCompany: /^(?:\+972-?|0)(?:5\d|[2-9]|7\d)(?:-)?\d{7}$/,
  licenseNumber:
    /^([0-9]{2}-[0-9]{3}-[0-9]{2}|[0-9]{3}-[0-9]{2}-[0-9]{3}|[0-9]{7,8})$/,
  licenceOrChassis:
    /^(([0-9]{2}-[0-9]{3}-[0-9]{2}|[0-9]{3}-[0-9]{2}-[0-9]{3}|[0-9]{7,8})|([A-Z]{2}[A-Z0-9]{12}))$/,
  companyId: /^51\d{7}$/,
  amount: /^₪?\d*$/,
}

export const invalid = {
  numbers: "יש להזין ספרות בלבד",
  fullName: "שם מלא לא תקין",
  name: "יש להזין אותיות בעברית / אנגלית בלבד",
  email: "כתובת המייל אינה תקינה",
  phoneNumber: "מספר הטלפון אינו תקין",
  licenseNumber: "נא להזין מספר בעל 7-8 תווים המורכב מספרות בלבד",
  licenceOrChassis: "מספר רישוי או שילדה לא תקין",
  amount: "ניתן להכניס ספרות בלבד",
  companyId: "יש להזין מס' ח.פ. תקין",
  groupPurchaseAmount: "הסכום שהזנת גדול מהסכום שניתן לרכוש",
}

export const schemaCommon = {
  phoneNumberCompany: yup
    .string()
    .matches(regex.phoneNumberCompany, "יש להזין מספר טלפון תקין")
    .required(required.default)
    .max(11, "יש להזין עד 10 ספרות בלבד"),
  phoneNumber: yup
    .string()
    .matches(regex.phoneNumber, "יש להזין מספר טלפון תקין")
    .required(required.default)
    .min(10, "יש להזין לפחות 10 ספרות")
    .max(12, "יש להזין עד 10 ספרות בלבד"),
  firstName: yup
    .string()
    .trim()
    .matches(regex.singleName, "ניתן להזין אותיות בלבד, כולל מקף או גרש")
    .min(2, "יש להזין לפחות שתי אותיות")
    .required(required.default)
    .max(30, "ניתן להזין עד 30 תווים")
    .test(
      "not-only-spaces",
      "יש להזין שם שאינו ריק",
      (value) => !!value && value.trim().length > 0
    ),
  lastName: yup
    .string()
    .trim()
    .matches(regex.singleName, "ניתן להזין אותיות בלבד, כולל מקף או גרש")
    .min(2, "יש להזין לפחות שתי אותיות")
    .required(required.default)
    .max(30, "ניתן להזין עד 30 תווים")
    .test(
      "not-only-spaces",
      "יש להזין שם שאינו ריק",
      (value) => !!value && value.trim().length > 0
    ),
  fullName: yup
    .string()
    .trim()
    .matches(regex.singleName, "ניתן להזין אותיות בלבד, כולל מקף או גרש")
    .min(2, "יש להזין לפחות שתי אותיות")
    .required(required.default)
    .max(30, "ניתן להזין עד 30 תווים")
    .test(
      "not-only-spaces",
      "יש להזין שם שאינו ריק",
      (value) => !!value && value.trim().length > 0
    ),
  email: yup
    .string()
    .email("יש להזין כתובת מייל תקינה")
    .required(required.default),
  recipientEmail: yup.string().email("יש להזין כתובת מייל תקינה"),
  city: yup.string(),
  street: yup.string(),
  apartmentNumber: yup.string().matches(regex.numbers, invalid.numbers),
  floorNumber: yup.string().matches(regex.numbers, invalid.numbers),
  entranceNumber: yup.string().matches(regex.numbers, invalid.numbers),
  comments: yup.string(),
  checkbox: yup.bool().oneOf([true], "יש לאשר את תנאי השימוש"),
  qauntity: yup.number().min(1, "יש לבחור כמות גיפטקארדים לרכישה"),
  amount: yup
    .string()
    .matches(regex.amount, invalid.amount)
    .required(required.default),
  companyId: yup
    .string()
    .matches(regex.companyId, invalid.companyId)
    .required(required.default),
  groupName: yup
    .string()
    .min(2, "יש להזין מינימום 2 תווים")
    .required("יש להזין מינימום 2 תווים")
    .max(50, "ניתן להזין עד 50 תווים"),
  senderBlessing: yup.string().max(200, "ניתן להזין עד 200 תווים"),
}
